var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("public.list"),
            visible: _vm.dialogFormVisible,
            width: "920px",
            modal: true,
            "close-on-click-modal": true,
            "custom-class": "person",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.dataTable } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("setting.headportrait"),
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("img", {
                          staticClass: "avatar",
                          attrs: { src: scope.row.user.avatar, alt: "" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "user.real_name",
                  label: _vm.$t("toptable.name"),
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "user.phone",
                  label: _vm.$t("toptable.phone"),
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "created_at",
                  label: _vm.$t("toptable.invitationtime"),
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "user.phone",
                  label: "用户状态",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === -1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "mini" } },
                              [_vm._v(" 待处理 ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [_vm._v(" 已拒绝 ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v(" 已同意 ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "user.phone",
                  label: "审核状态",
                  "min-width": "100",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.status === 1
                          ? [
                              scope.row.verify === -1
                                ? _c(
                                    "el-tag",
                                    { attrs: { type: "danger", size: "mini" } },
                                    [_vm._v(" 已拒绝 ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.verify === 0
                                ? _c(
                                    "el-tag",
                                    { attrs: { type: "danger", size: "mini" } },
                                    [_vm._v(" 待审核 ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.verify === 1
                                ? _c(
                                    "el-tag",
                                    { attrs: { type: "info", size: "mini" } },
                                    [_vm._v(" 已同意 ")]
                                  )
                                : _vm._e(),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "160", label: _vm.$t("toptable.operation") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(
                                  scope.row.id,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("public.delete")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        scope.row.status == 1 && scope.row.verify == 0
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAgree(scope.row.id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("toptable.agree")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRefuse(scope.row.id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("toptable.refuse")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.limit,
              "current-page": _vm.page,
              layout: "total,prev, pager, next, jumper",
              total: _vm.total,
            },
            on: { "current-change": _vm.pageChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }